import { STORES_API } from 'modules/stores/api/stores-api'
import { StoreId, StoreInterface } from 'modules/stores/types/stores-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export const useStore = (storeId?: StoreId) => {
  const { user } = useUser()

  const { fetcher } = useFetch<RequestMethodsEnum.get, StoreInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data, mutate } = useControlledSwr(
    [`${STORES_API}/${storeId}`, RequestModuleEnum.MembershipLightCourse],
    fetcher,
    undefined,
    !!user && !!storeId,
  )

  return {
    data,
    mutate,
  }
}
